import React from "react";
import "../Terms&Conditions/Terms&Conditions.css";

const TermsAndConditions = () => {
  return (
    <>
      <div className="full-terms">
        <div className="terms-conditions-container">
          <h2 className="section-title">Terms and Conditions</h2>

          <div className="sectionn">
            <h3>YOUR CONTRACT — PLEASE READ THIS CAREFULLY BEFORE YOU BOOK</h3>
            <p>
              These booking terms and conditions govern all bookings that you
              make with <strong> Journey Experts Limited of 124 City Road, London, EC1V 2NX.</strong> Please read them carefully as they set out
              our respective rights and obligations. In these booking conditions
              references to "we" and "us" indicate Journey Experts Limited (the
              Company) and references to "you" and "your" include the first
              named person on the booking and all persons on whose behalf a
              booking is made or any other person to whom a booking is added or
              transferred. Your use of this website is expressly conditioned on
              your acceptance of the following terms and conditions. If you do
              not agree with any part of the following terms and conditions, you
              must not use this site.
            </p>
            <p>
              We act in the following capacities: as a Flight-Plus Arranger, and
              as an agent to help you to arrange individual flight only,
              accommodation only or other separate travel arrangements
              ("Individual Components"). Our obligations to you may vary
              depending upon which arrangements you book with us, and we have
              tried to set them out below as clearly as possible. Section A
              contains the conditions which will apply to all bookings, and
              Section B applies to agency bookings (including Flight-Plus). We
              act as agent in the sale of Flight Plus products.
            </p>
          </div>

          <div className="sectionn">
            <h3>SECTION A – APPLICABLE TO ALL BOOKINGS</h3>

            <h4>Booking Your Travel Arrangements</h4>
            <p>
              All services offered are subject to availability. When you make a
              booking, you confirm that you have the authority to accept, and do
              accept these conditions on your behalf and on behalf of all
              members of your party and further, if you are making a booking for
              more than one person, that you are responsible for all payments
              due from each and every party member for whom you are making a
              booking. It is your responsibility to ensure that any information
              which you give us is accurate and that information which is given
              to you by us or any of our suppliers is passed on to all members
              of your party.
            </p>
            <p>
              When you make your booking you must pay the relevant deposit as
              specified at the time of booking. No contract will come into
              existence until we accept your booking and we receive your deposit
              or full payment in cleared funds and issue you with a confirmation
              invoice either on behalf of ourselves or the supplier in question.
              Please ensure that the names given are the same as in the relevant
              passport.
            </p>
            <p>
              Bookings made online: If you book online, you must provide us with
              all information which we require. You must also ensure that the
              credit or debit card you are using is your own (or, subject to our
              agreement, if it is a third party's you have their express
              authorization, to use their credit or debit card) and that
              sufficient funds are available to cover the cost of the
              arrangements which you book with us. When we receive and accept
              your booking we will send you a confirmation e-mail and invoice
              and debit payment from you. We do not make any representation or
              warranty as to the availability of any package holiday, flight or
              Individual Components nor that our booking services are free from
              infection of viruses or anything else that has a contaminating or
              destructive effect on your property.
            </p>

            <h4>Bookings made by telephone: </h4>
            <p>
              If you make a booking by telephone you must provide us with all
              information which we require. You must also ensure that all
              information which you provide is accurate and that the credit or
              debit card you are using is your own or, subject to our agreement,
              if it is a third party's you have their express authorization to
              use their credit or debit card and that sufficient funds are
              available to cover the cost of the arrangements which you book
              with us. If we accept your booking, we shall debit payment from
              you and send you a confirmation invoice. From this point
              cancellation charges will apply: Please note that a telephone
              booking confirmation is as firmly confirmed as if it were made
              /confirmed in writing immediately. As soon as you receive the
              confirmation, please check the details carefully and inform us
              immediately if anything appears to be incorrect as it may not be
              possible to make changes later.
            </p>

            <h4>Payments</h4>
            <p>
              You must pay the balance by the due date shown on the confirmation
              invoice. Please note for some telephone bookings full payment may
              be required IMMEDIATELY i.e. before you receive the confirmation
              invoice. If this applies you will be advised when the booking is
              made. It is very important that you pay balances when due because
              failure to do so may lead to the cancellation of your
              holiday/flights and still leave you liable to pay cancellation
              charges. Where an extra "booking charge" applies this will have
              been advised at the time of booking. All credit/charge card
              payments are subject to a surcharge. All cheque payments require 7
              days to clear. Until full payment has been received the price of
              your booking may increase as a result of fuel or other surcharges
              which may be imposed by suppliers. Please note we do not accept
              responsibility for cash sent by courier or post, even if sent by
              registered or recorded delivery post or any other special
              delivery.
            </p>
            <p>
              Any money paid to an authorized agent of ours in respect of a
              booking covered by our ATOL is held by that agent on behalf of and
              for the benefit of the Trustees of the Air Travel Trust at all
              times, but subject to the agent's obligation to pay it to us for
              so long as we do not fail financially. If we do fail financially,
              any money held at that time by the agent or subsequently accepted
              from the consumer by the agent, is and continues to be held by
              that agent on behalf of and for the benefit of the Trustees of the
              Air Travel Trust without any obligation to pay that money to us.
            </p>
          </div>

          <div className="sectionn">
            <h3>Data Protection Policy</h3>
            <p>
              In order to process your booking and to ensure that your travel
              arrangements run smoothly and meet your requirements, we need to
              use the information you provide. Please see our Data Protection
              and Privacy Policy here for further information.
            </p>
          </div>

          <div className="sectionn">
            <h3>Passports, Visa, and Health Requirements</h3>
            <p>
              You are responsible for checking all passport, visa and health
              requirements and ensuring your travel documents are in order.
            </p>
            <p>
              Passport and Visa: You must consult the relevant Embassy or
              Consulate for this information. Requirements may change and you
              should check the up-to-date position in good time before
              booking/departure. We accept no liability if you are refused entry
              onto the flight or into any country due to failure on your part to
              carry the correct passport, visa or other documents required by
              any airline, authority or country. You must have a passport which
              is valid for six months after your intended date of return. You
              must ensure you have correct visa and health entry requirements
              for all countries visited including countries you may just be
              transiting through. This includes all stops made by the aircraft
              even if you do not leave the aircraft or airport. If your passport
              is in its final year, you should check with the Embassy of the
              country you are visiting. For further information contact the
              Passport Office. Special conditions apply for travel to the USA,
              and all passengers must have individual machine readable
              passports. Please check www.usembassy.org.uk. For European
              holidays you should obtain a completed and issued form EHIC prior
              to departure
            </p>
            <p>
              Up to date travel advice and entry requirements can be obtained
              from the Foreign and Commonwealth Office, visit www.fco.gov.uk.
            </p>
          </div>

          <div className="sectionn">
            <h3>Health </h3>
            <p>
              Recommended inoculations for travel may change at any time and you
              should consult your doctor on current recommendations before you
              depart. Health requirements for your holiday destination are
              outlined in the Department of Health leaflet entitled "The
              Traveller's Guide to Health" (T4), which is available by calling
              0800 555 777. It is your responsibility to ensure that you obtain
              the recommended inoculations, take all recommended medication and
              follow all medical advice in relation to your trip. For useful
              information, check immunisation website atwww.immunisation.nhs.uk
              and the National Travel Health Network and Centre website at
              www.nathnac.org.
            </p>
            <p>
              We do not accept any responsibility if you cannot travel, or incur
              any other loss because you have not complied with any passport,
              visa, immigration requirements or health formalities. You agree to
              reimburse us in relation to any fines or other losses which we
              incur as a result of your failure to comply with any passport,
              visa, immigration requirements or health formalities.{" "}
            </p>
          </div>

          <div className="sectionn">
            <h3>Special Requests and Medical Problems </h3>
            <p>
              If you have any special requests, please advise us at time of
              booking. Although we will endeavour to pass any such requests on
              to the relevant supplier, we regret we cannot guarantee any
              request will be met. Failure to meet any special request will not
              be a breach of contract on our part. If you have any medical
              problem or disability which may affect your arrangements, you must
              advise us in writing before of booking giving full details.
              Regrettably, many overseas destinations do not have even basic
              facilities required by disabled travelers. If we feel unable to
              properly accommodate your particular needs, we must reserve the
              right to decline/cancel your booking, and charge any applicable
              cancellation charges.
            </p>
          </div>

          <div className="sectionn">
            <h3>Behavior </h3>
            <p>
              You accept responsibility to ensure that you & the members of your
              party do not behave in a way which causes offence to others or
              risks any loss or damage to property belonging to others. Payments
              for any such damage or loss must be made at the time direct to the
              accommodation owner or manager or other supplier. You indemnify us
              against any claims (including legal costs) subsequently made
              against us as a result of your actions. We expect all clients to
              have consideration for other people. If in our reasonable opinion
              or in the opinion of any other persons in authority you are
              behaving in such a way to cause or to be likely to cause distress,
              danger or annoyance to any third party or damage to property, we
              reserve the right to terminate your arrangements without notice.
              In this situation your total booking with us, including your
              return transportation arrangements, will immediately cease and we
              will not be responsible for paying any costs, expenses, refunds or
              compensation.
            </p>
          </div>

          <div className="sectionn">
            <h3>Compliance with laws</h3>
            <p>
              It is also your responsibility to comply with the laws, customs,
              foreign exchange and the drug regulations of the countries
              visited. We and/or our representatives reserve the right to cancel
              your holiday at any time if in our reasonable opinion you are
              found to be behaving in a socially unacceptable manner or
              indulging in illegal activities, without any liability to you for
              any refund and legal claim.
            </p>
          </div>

          <div className="sectionn">
            <h3>Force Majeure</h3>
            <p>
              We will not pay you compensation and will not be held responsible,
              if we have to cancel or change your travel arrangements in any way
              because of unusual or unforeseeable circumstances beyond our
              control. These can include war or threat of war, civil strife,
              industrial dispute including air traffic control disputes,
              terrorist activity and its consequences, natural and nuclear
              disaster, fire or adverse weather conditions, epidemics &
              pandemics, unavoidable technical problems with transport, closure
              or congestion of airports or ports and all similar events outside
              our or the supplier(s) concerned's control. Advice from the
              Foreign Office to avoid or leave a particular country may
              constitute Force Majeure. You can check the current position of
              any country by telephoning the Foreign and Commonwealth Office's
              Travel Advice Unit on 0845 850 2829.
            </p>
          </div>

          <div className="sectionn">
            <h3>Insurance </h3>
            <p>
              Adequate travel insurance is a condition of your contract with
              either us or the supplier in question, as applicable. You may take
              the holiday insurance offered by us or arrange it independently.
              The insurance cover must include cancellation charges, unexpected
              curtailment of your holiday, medical and repatriation expenses
              including air ambulance, personal accident, delay loss or damage
              to your personal effects. When arranging insurance from a source
              other then offered by us, you must provide us with written details
              of the policy and sign an indemnity form on behalf of yourself and
              all members of your party absolving us and our overseas agents
              /representatives, of any liability for any costs that may arise
              which otherwise would have been met by the insurance claim.
            </p>
          </div>
          <div className="sectionn">
            <h3>Telephone Calls</h3>
            <p>
              We reserve the right to randomly record telephone calls to ensure
              that our customer service is constantly reviewed.
            </p>
          </div>
          <div className="sectionn">
            <h3>Claims and Complaints</h3>
            <p>
              Where we are acting as agent, the contract for your arrangements
              is between you and the supplier and any queries or concerns should
              be addressed to them. If you have a problem whilst on holiday,
              this must be reported to the supplier or their local supplier or
              agent immediately. If you fail to follow this procedure there will
              be less opportunity to investigate and rectify your complaint. The
              amount of compensation you may be entitled to may be reduced or
              you may not receive any at all depending upon the circumstances.
              If you wish to complain when you return home, write to the
              supplier. You will see the name and address plus contact details
              in any confirmation documents we send you. We will of course
              assist you with this if you wish - please contact Customer
              Services. If the matter cannot be resolved and it involves us or
              another ATOL member then it can be referred to the arbitration
              scheme arranged by ATOL, details of which are below
            </p>
          </div>
          <div className="sectionn">
            <h3>Your Financial Protection</h3>
            <p>
              We provide financial security for flight inclusive Packages,
              Flight Plus bookings and ATOL protected flights through our ATOL
              License (number 11037) issued by the Civil Aviation Authority.
            </p>
            <p>
              If you have booked a flight where the ticket is not issued
              immediately, your flight will be protected under our ATOL. When
              you buy an ATOL protected flight & flight plus or flight inclusive
              holiday from us you will receive an ATOL Certificate. This lists
              what is financially protected, where you can get information on
              what this means for you and who to contact if things go wrong. For
              further information, visit the ATOL website at www.atol.org.uk.
              The price of our flight inclusive arrangements includes the amount
              of £2.50 per person as part of the ATOL Protection Contribution
              (APC) we pay to the CAA. This charge is included in our advertised
              prices. Not all holiday or travel services offered and sold by us
              will be protected by the ATOL Scheme. ATOL protection extends
              primarily to Customers who book and pay in the United Kingdom.
            </p>
            <p>
              We, or the suppliers identified on your ATOL Certificate, will
              provide you with the services listed on the ATOL Certificate (or a
              suitable alternative). In some cases, where neither we nor the
              supplier are able to do so for reasons of insolvency, an
              alternative ATOL holder may provide you with the services you have
              bought (at no extra cost to you). You agree to accept that in
              those circumstances the alternative ATOL holder will perform those
              obligations and you agree to pay any money outstanding to be paid
              by you under your contract to that alternative ATOL holder.
              However, you also agree that in some cases it will not be possible
              to appoint an alternative ATOL holder, in which case you will be
              entitled to make a claim under the ATOL Scheme (or your credit
              card issuer where applicable).
            </p>
            <p>
              If we, or the suppliers identified on your ATOL certificate, are
              unable to provide the services listed (or a suitable alternative,
              through an alternative ATOL holder or otherwise) for reasons of
              insolvency, the Trustees of the Air Travel Trust may make a
              payment to (or confer a benefit on) you under the ATOL scheme. You
              agree that in return for such a payment or benefit you assign
              absolutely to those Trustees any claims which you have or may have
              arising out of or relating to the non-provision of the services,
              including any claim against us, the travel agent (or your credit
              card issuer where applicable). You also agree that any such claims
              may be re-assigned to another body, if that other body has paid
              sums you have claimed under the ATOL scheme.
            </p>
            <p>
              If you book arrangements the CAA. Other than an ATOL protected
              flight, package holiday or Flight-Plus from this brochure/website,
              your monies will not be financially protected. Please ask us for
              further details.
            </p>
          </div>
          <div className="sectionn">
            <h3>Conditions of Suppliers</h3>
            <p>
              Many of the services which make up your holiday are provided by
              independent suppliers. Those suppliers provide these services in
              accordance with their own terms and conditions which will form
              part of your contract with us or the applicable supplier. Some of
              these terms and conditions may limit or exclude the supplier's
              liability to you, usually in accordance with applicable
              International Conventions. Copies of the relevant parts of these
              terms and conditions are available on request from ourselves or
              the supplier concerned.
            </p>
          </div>
          <div className="sectionn">
            <h3>Jurisdiction</h3>
            <p>
              This contract is governed by the English Law, and any dispute
              arising between the parties is subject to the exclusive
              jurisdiction of the courts of England. You may, however, choose
              the law and jurisdiction of Scotland or Northern Ireland.
            </p>
          </div>

          <div className="sectionn">
            <h3>Flights and Flight Travel Documents </h3>
            <p>
              Please note that a flight described in your flight ticket as
              "direct" will not necessarily be non-stop. All departure/arrival
              times on your flight ticket are provided by the airlines concerned
              and are estimates only. They may change due to air traffic control
              restrictions, weather conditions, operational/maintenance
              requirements and the requirement for passengers to check in on
              time.{" "}
            </p>
            <p>
              We are unable to make any special arrangements for you if you are
              delayed; these matters are at the sole discretion of the airline
              concerned.{" "}
            </p>
            <p>
              In relation to flights, an infant must be under 2 years of age on
              the date of their return flight to be entitled to the infant fare
              level which is usually 10% of IATA's published fare.
            </p>
            <p>
              Please note that where a sector of a flight itinerary is not
              utilised without contacting the carrier directly any remaining
              sectors may be subject to cancellation without further
              notification. Where this situation arises we are unable to accept
              responsibility for any costs incurred. In accordance with EU
              regulations we are required to bring to your attention the
              existence of a 'Community list', which contains details of air
              carriers that are subject to an operating ban within the EU
              Community. The Community list is available for inspection at
              http://ec.europa.eu/transport/air-ban.{" "}
            </p>
            <p>
              We reserve the right to change the airline in the event that the
              airline is blacklisted under the EU regulations. Any changes to
              the actual airline after you have received your tickets will be
              notified to you as soon as possible and in all cases at check-in
              or at the boarding gate.{" "}
            </p>
          </div>
          <div className="sectionn">
            <h3>Reconfirming all Flights</h3>
            <p>
              You must telephone us or the airline at least 72 hours before the
              departure time shown on your ticket to confirm that there have
              been no changes. This applies to both outbound and return flights.
              We will not be liable for any additional costs due to your failure
              to reconfirm flights. Reconfirming your flight at least 72 hours
              before departure is a minimum requirement.
            </p>
          </div>
          <div className="sectionn">
            <h3>Travel Documents Checking and Dispatch </h3>
            <p>
              Travel documents will be sent by email. It is your responsibility
              to check that all travel documents issued are correct. Any
              inaccuracies must be notified to us immediately. If you do not
              contact us immediately we cannot accept any liability and any
              changes may incur additional cost as applicable. The address for
              sending all documentation will be that given at the time of
              booking unless requested otherwise. Travel documents will not be
              sent until we receive the full payment in the cleared funds.
              Documents will normally be sent 7 days before departure. Sending
              travel documents by post or fax is subject to company's discretion
              and will involve additional cost. In the event of travel document
              lost or delayed in delivery, it will be your responsibility to pay
              additional expenses incurred by us to arrange and send duplicate
              travel documents.{" "}
            </p>
          </div>
          <div className="sectionn">
            <h3>Late Bookings</h3>
            <p>
              May also require Special/Courier delivery of documents in which
              case we will tell you the charges at the time of booking.{" "}
            </p>
          </div>
          <div className="sectionn">
            <h3>Special Price Guarantee</h3>
            <p>
              For all scheduled flights, if you can get a cheaper flight on the
              same carrier and departing at the same day and time on the same
              route within 24 hours of making the booking with us (as time and
              date on your invoice) we will match the price (written proof
              required) or if we cannot we will refund your deposit. If you
              require the ticket within 24 hours the above does not apply. Fares
              are subject to change without prior notice.{" "}
            </p>
          </div>
          <div className="sectionn">
            <h3>E-Tickets </h3>
            <p>
              Some airlines offer only electronic confirmation of your
              reservation, or 'e-ticketing', on certain routes. If you are
              travelling on an e-ticket route we can at your request provide you
              with a paper ticket where permitted. Where you make a request for
              a paper ticket, an administration fee of £10 per ticket will be
              levied in addition to any applicable airline charge.
            </p>
          </div>
          <div className="sectionn">
            <h3>Airline Ticket Refunds </h3>
            <p>
              Air tickets returned to us for a refund are subject to an
              administration charge of £50 per ticket, irrespective of the
              number of tickets returned and you will be required to pay a per
              ticket cancellation charge imposed by the airline or the
              consolidator pursuant to their terms and conditions. There is no
              automatic right to a refund and, when you return an air ticket to
              us, we will arrange for it to be presented to the respective
              airline or consolidator to assess eligibility for a possible
              refund in accordance with the relevant airline's or consolidator's
              terms and conditions. We recommend that you return such air
              tickets to us by special delivery post as we do not accept
              responsibility for documents mislaid or lost by the Royal Mail. If
              a recoverable air ticket refund is less than the above
              administration charge, the ticket will be deemed to be fully
              non-refundable. An administration fee of £50 per ticket will be
              levied on any non-refundable ticket where a tax refund application
              is made by us at your request and on your behalf. If the
              recoverable tax components for your ticket are less than the
              administration charge the ticket will be deemed to be fully
              non-refundable. Refunds will not be paid to you until they have
              been received by us from the relevant airline or consolidator. In
              the case of airline ticket refunds this is normally 10-12 weeks
              from the point the tickets are submitted for consideration to the
              airline.{" "}
            </p>
          </div>
          <div className="sectionn">
            <h3>Scheduled Airline Failure Administration Fee </h3>
            <p>
              If you are holding a ticket(s) on an airline which fails due to
              insolvency and has ceased flying, the money you have paid for your
              ticket(s) may be lost. As part of the requirements under our ATOL
              licence issued by the Civil Aviation Authority to protect our
              customers, we undertake to ensure that, should this happen, our
              customers receive compensation for their loss to the extent
              referred to below. In the event of a scheduled airline failure as
              a result of an insolvent winding-up: prior to commencement of a
              passenger's trip, all monies paid by the passenger either as a
              deposit, or as the case may be, as the price for the scheduled
              airline ticket(s) will be refunded to the passenger in full; or
              After the passenger's trip has commenced: the sum equivalent to
              the price paid for the ticket(s) for such scheduled airline
              flights forming part of the trip as were cancelled as a direct
              result of the airline failure will be refunded to the passenger in
              full; or if the trip is curtailed forthwith upon the airline
              failure, the cost of direct return transportation to the United
              Kingdom to a similar standard to that originally booked as part of
              the trip, such return flight commencing at the point of
              curtailment of the trip as the direct result of the airline
              failure.{" "}
            </p>
            <p>
              As a fee for our administering both the claims and/or the
              repatriation of passengers we will charge each customer a nominal
              administration fee for this service. This fee forms part of the
              cost of each airline ticket purchased from us and is not optional.{" "}
            </p>
          </div>
          <div className="sectionn">
            <h3>Flight Changes </h3>
            <p>
              Should your flight be cancelled your rights and remedies will be
              governed by the airline's conditions of carriage. As a result you
              may be entitled to: (a) Carriage on another flight with the same
              airline without additional costs; (b) Re-routing to your
              destination with another carrier without additional costs; (c)
              Receiving a full refund; or (d) Some other right or remedy.
            </p>
            <p>
              If a schedule change occurs to your itinerary prior to our receipt
              from you of the full price, or prior to the issue of your tickets
              (on either the outbound or return flight) we will do our best to
              notify you on behalf of the carrier
            </p>
            <p>
              Should a schedule change occur to your itinerary after full
              balance/ticket issue, on either the outbound or return flights the
              relevant supplier's decision will be final and amendment charges
              may apply.{" "}
            </p>
          </div>
          <div className="sectionn">
            <h3>Departure Taxes </h3>
            <p>
              It is not always possible to include all departure taxes on your
              ticket(s). In some cases departure taxes must be paid by you
              locally to the Government of the country you are departing from
              and are non-refundable by us.{" "}
            </p>
          </div>
          <div className="sectionn">
            <h3>SECTION B: AGENCY BOOKING AND FLIGHT PLUS ARRANGEMENTS</h3>
            <p>
              This section applies to bookings we make for you when acting as
              agent.{" "}
            </p>
          </div>
          <div className="sectionn">
            <h3>Your contract </h3>
            <p>
              If you book Individual Components or a Flight Plus with us, we
              will make the booking as agent for the relevant supplier(s) (e.g.
              the airline or hotel supplier) and we will arrange for you to
              enter into a contract with the applicable supplier. Your contract
              will be subject to the supplier's own terms and conditions which
              could limit or exclude liability to you, often in accordance with
              international conventions. Copies of the supplier's terms and the
              international conventions are available on request. As an agent we
              accept no responsibility for the acts or omissions of the supplier
              or for the services provided by the supplier. You may wish to
              purchase flights, hotel, car rental, transfer services or other
              services on our website. Each component will be provided by
              different third party providers of the products you have selected.
              Your contract will be with the individual suppliers and not with
              us. Since you create your own travel arrangements by adding each
              component separately to create your own bespoke booking, this is
              not a package and therefore you are not protected under the
              Package Travel Regulations and unless you book a Flight-Plus, your
              booking may not benefit from ATOL protection either. Until a
              component has been confirmed by the individual supplier, no
              contract has been formed.{" "}
            </p>
          </div>
          <div className="sectionn">
            <h3>Changes By You</h3>
            <p>
              Any cancellation or amendment request must be sent to us in
              writing and will not take effect until received by us. If you
              cancel or amend your booking the supplier may charge the
              cancellation or amendment charge shown in their Terms and
              Conditions (which may be 100% of the cost of the travel
              arrangements) and you will have to pay an Amendment Fee per person
              which will be notified at the time of change as well as any
              applicable cancellation charges.{" "}
            </p>
          </div>
          <div className="sectionn">
            <h3>Cancellation By You</h3>
            <p>
              Air Ticket Refund: Many airline tickets are paid for in full at
              the time of booking and in case of cancellation, unless otherwise
              stated, they are nonrefundable, non-changeable and non
              re-routable. In respect of any alteration to an APEX ticket or
              certain other special fare tickets, some suppliers (particularly
              airlines) may treat a name change as a cancellation and as such
              will not refund any monies. Where an outbound portion of your
              flight coupon is not used the return sector will be automatically
              cancelled by the airline and no automatic right to a refund exists
              for such part-used tickets. All other partly used tickets are
              normally nonrefundable and cancellations made within 24 hours of
              departure are non-refundable.
            </p>
            <p>
              Other Individual Components: For all other Individual Components,
              unless your confirmation invoice or the supplier's terms and
              conditions specifies different cancellation charges, the charges
              below shall apply:{" "}
            </p>
            <p>Prior to Balance being collected: Deposit Only</p>
            <p>
              After Balance has been paid: 100% of the cost of the Individual
              Component You will be notified of the exact charges at the time of
              amendment or cancellation.
            </p>
          </div>
          <div className="sectionn">
            <h3>Changes or Cancellations by the Supplier </h3>
            <p>
              We will inform you of any changes or cancellations as soon as
              reasonably possible. If the supplier offers alternative
              arrangements or a refund, you will need to let us know your choice
              within the time frame we stipulate. If you fail to do so the
              supplier is entitled to assume you wish to receive a full refund.
              We accept no liability for any changes or cancellations made to
              your arrangements by the supplier under your contract with them.{" "}
            </p>
          </div>
          <div className="sectionn">
            <h3>Payment </h3>
            <p>
              If you have paid a deposit, you must pay the full balance by the
              balance due date notified to you. If full payment is not received
              by the balance due date, we will notify the supplier who may
              cancel your booking and charge the cancellation fees set out in
              their booking conditions. Except where otherwise advised or stated
              in the booking conditions of the supplier concerned, all monies
              you pay to us for arrangements will be held on behalf of the
              supplier(s) concerned.
            </p>
          </div>
          <div className="sectionn">
            <h3>Our responsibility for your booking </h3>
            <p>
              Your contract is with the supplier and its booking conditions
              apply. As agent, we accept no responsibility for the actual
              provision of the arrangements. Our responsibilities are limited to
              making the booking in accordance with your instructions. We accept
              no responsibility for any information about the arrangements that
              we pass on to you in good faith. However, in the event that we are
              found liable to you on any basis whatsoever, our maximum liability
              to you is limited to twice the cost of your booking (or the
              appropriate proportion of this if not everyone on the booking is
              affected). We do not exclude or limit any liability for death or
              personal injury that arises as a result of our negligence or that
              of any of our employees whilst acting in the course of their
              employment.{" "}
            </p>
          </div>
          <div className="sectionn">
            <h3>Flight-Plus bookings </h3>
            <p>
              Booking a Flight-Plus provides you with protection under our ATOL
              in the event of supplier insolvency, but we are still acting as
              agent for the individual suppliers and a Flight-Plus booking does
              not constitute a package as described in section B above. A
              Flight-Plus exists where you request to book a flight out of the
              UK, or a flight into the UK where you departed from the UK by
              another means and on the same day, the day before or the day
              after, you also request to book either living accommodation or
              self-drive car hire which takes place outside the UK and is
              supplied under or in connection with your flight. In all cases the
              services must cover a period of more than twenty four hours or
              include overnight living accommodation in order to make them a
              Flight-Plus. If in connection with the flight, you also book any
              other tourist services which are not ancillary to flight or living
              accommodation and which account for a significant proportion of
              the Flight-Plus, they will also form part of the Flight-Plus.
            </p>
            <p>
              A Flight-Plus will also exist where on the same day, the day
              before or the day after you have requestedto book: a) a non-flight
              inclusive Package, you request to book a flight out of the UK, or
              a flight into the UK where you departed from the UK by another
              means or b) a flight inclusive Package, you request to book
              accommodation or self-drive car hire outside the UK. (A Package
              exists if you book a pre-arranged combination of at least two of
              the following components when sold or offered for sale at an
              inclusive price and when the service covers a period of more than
              twenty-four hours or includes overnight accommodation:-(a)
              transport; (b) accommodation; (c) other tourist services not
              ancillary to transport or accommodation and accounting for a
              significant proportion of the Package.) Please note that a single
              flight which begins and ends in the United Kingdom will not form
              part of a Flight-Plus. Where you request to book a Flight-Plus, we
              will be a Flight-Plus Arranger in accordance with the definitions
              set out in Regulation 25 of The Civil Aviation (Air Travel
              Organisers' Licensing) Regulations 2012. Please note that where
              you book a low cost flight only and make payment directly to the
              airline, this will not constitute a Flight-Plus.
            </p>
          </div>
          <div className="sectionn">
            <h3>Our liability for Flight-Plus bookings </h3>
            <p>
              In these conditions, the failure or insolvency of a provider will
              have the meaning prescribed in Regulation 23 of the ATOL
              Regulations 2012. If, before your intended departure on a
              Flight-Plus we become aware that any part of your Flight-Plus will
              not be provided a) because of the insolvency of any person
              concerned with the provision of the arrangements making up a
              Flight-Plus or b) because the ATOL holder providing your flight
              accommodation is insolvent, cannot or will not be able to meet, or
              will fail to meet its obligations to its customers, we will make
              reasonable endeavours to provide you with suitable alternative
              arrangements at no extra cost. If it is impossible to make such
              arrangements, we will give you a full refund of all monies paid to
              us in respect of your Flight-Plus.
            </p>
            <p>
              If, after your intended departure on a Flight-Plus we become aware
              your flight arrangements will not be provided a) because of the
              insolvency of any person concerned with the provision of the
              flight accommodation making up your Flight-Plus or b) because the
              ATOL holder providing your flight accommodation is insolvent,
              cannot or will not be able to meet, or will fail to meet its
              obligations to its customers, we or the CAA will seek to provide
              you with suitable alternative transport back to the place of
              departure or to another return point to which you have agreed.{" "}
            </p>
            <p>
              If, after your intended departure on a Flight-Plus we become aware
              that your living accommodation or car hire will not be provided
              because of the insolvency of any person concerned with the
              provision of the living accommodation or car hire making up your
              Flight-Plus, we will seek to provide you with suitable alternative
              living accommodation or car hire at no extra cost. If it is
              impossible to make such arrangements, we will give you a full
              refund of all monies paid to us in respect of all unused flight
              accommodation, living accommodation, car hire and other tourist
              services forming part of your Flight-Plus.
            </p>
            <p>
              Where suitable alternative arrangements are provided as set out in
              this section, we will where appropriate, pay you reasonable
              compensation, to include any incidental expenses reasonably
              incurred by you and evidenced by receipts. Compensation will not
              be payable if living accommodation or self-drive car hire is
              offered by us and accepted by you with a higher price than that
              originally booked and is supplied in the same location as
              originally booked where no additional payment is made by you.{" "}
            </p>
            <p>
              If cancellation occurs for reasons other than relating to
              insolvency, we will not be liable to pay you compensation and the
              above options will not be available. As agent, whether or not we
              have sold you a Flight-Plus, we will not be liable in respect of
              quality complaints, any general losses, distress or disappointment
              suffered by you in relation to your booking, and any such claims
              must be directed to the relevant supplier of the element in
              question. We will not make suitable alternative arrangements or
              pay you compensation in respect of any tourist services forming
              part of your Flight-Plus. A refund will be given in respect of
              these services in the event of insolvency but we will have no
              further liability.{" "}
            </p>
            <p>
              We, or the suppliers of the services you have bought, will provide
              you with the services listed on the ATOL Certificate (or a
              suitable alternative). In some cases, where neither we nor the
              supplier are able do so for reasons of insolvency, an alternative
              ATOL holder may provide you with the services you have bought or a
              suitable alternative (at no extra cost to you). You agree to
              accept that in those circumstances the alternative ATOL holder
              will perform those obligations and you agree to pay any money
              outstanding to be paid by you under your contract to that
              alternative ATOL holder. However, you also agree that in some
              cases it will not be possible to appoint an alternative ATOL
              holder, in which case you will be entitled to make a claim under
              the ATOL scheme (or your credit card issuer where applicable).
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsAndConditions;
